import { useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || process.env.REACT_APP_LOCAL_API_URL;

function VerifyEmail() {
  const [params] = useSearchParams();
  const started = useRef(false);
  const [result, setResult] = useState({ loading: false, message: "", error: "" });
  async function verify() {
    if (started.current) return;
    started.current = true;
    setResult({ loading: true, message: "", error: "" });
    try {
      const response = await axios.post(`${API_URL}/auth/verify-email`, { token: params.get("token") });
      setResult({ loading: false, message: response.data.message, error: "" });
    } catch (error) {
      started.current = false;
      setResult({ loading: false, message: "", error: error.response?.data?.message || "Verifieringen misslyckades" });
    }
  }
  return <div className="mx-auto w-full max-w-xl px-4 py-6"><div className="theme-card text-center">
    <h1 className="text-lg font-bold text-slate-800">E-postverifiering</h1>
    {!result.message && <>
      <p className="mt-4">Tryck på knappen för att bekräfta din e-postadress.</p>
      <button className="theme-button-primary mt-4" onClick={verify} disabled={result.loading || !params.get("token")}>Verifiera min e-postadress</button>
      {!params.get("token") && <p className="theme-alert-error mt-3">Verifieringslänken saknas. Öppna länken i ditt verifieringsmejl.</p>}
    </>}
    {result.loading && <p className="mt-4 text-slate-600">Verifierar…</p>}
    {result.message && <div className="theme-alert-success mt-4">{result.message}</div>}
    {result.error && <div className="theme-alert-error mt-4">{result.error}</div>}
    <p className="mt-3">Vanliga nya konton behöver också administratörens godkännande.</p>
    <Link className="block mt-3 text-sky-700" to="/forgot-password">Sätt eller återställ lösenord</Link>
    <Link className="mt-4 inline-block font-semibold text-sky-700" to="/login">Till inloggningen</Link>
  </div></div>;
}

export default VerifyEmail;
